(function () {
  'use strict';

  function money(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((Number(cents) || 0) / 100);
  }

  var COLOUR_FAMILIES = [
    { key: 'black', aliases: ['black', 'ebony', 'night'] },
    { key: 'turquoise', aliases: ['aqua', 'aquamarine', 'teal', 'turquoise', 'mint', 'petrol'] },
    { key: 'blue', aliases: ['blue', 'navy', 'indigo', 'sky', 'duck egg'] },
    { key: 'red', aliases: ['red', 'scarlet', 'garnet', 'burgundy', 'cherry', 'currant', 'poppy'] },
    { key: 'pink', aliases: ['pink', 'blush', 'rose', 'raspberry', 'fuchsia'] },
    { key: 'green', aliases: ['green', 'sage', 'dusk', 'olive', 'seagrass', 'vetiver'] },
    { key: 'purple', aliases: ['purple', 'violet', 'plum', 'orchid', 'lavender'] },
    { key: 'brown', aliases: ['brown', 'cognac', 'chestnut', 'walnut', 'espresso', 'mocha'] },
    { key: 'beige', aliases: ['beige', 'oat', 'stone', 'almond', 'nude', 'fawn', 'taupe'] },
    { key: 'grey', aliases: ['grey', 'gray', 'granite', 'silver', 'charcoal', 'concrete'] },
    { key: 'yellow', aliases: ['yellow', 'lemon'] },
    { key: 'gold', aliases: ['ochre', 'mustard', 'gold'] },
    { key: 'white', aliases: ['white', 'snow', 'ivory'] }
  ];

  function normaliseColour(value) {
    var normalised = String(value || '').toLowerCase();
    if (normalised.normalize) normalised = normalised.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return normalised.replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function containsColourAlias(value, alias) {
    return (' ' + value + ' ').indexOf(' ' + alias + ' ') !== -1;
  }

  function colourKeys(value) {
    var keys = [];
    String(value || '').split('|').forEach(function (part) {
      var normalised = normaliseColour(part);
      if (!normalised) return;
      var family = COLOUR_FAMILIES.find(function (item) {
        return item.aliases.some(function (alias) { return containsColourAlias(normalised, alias); });
      });
      var key = family ? family.key : normalised;
      if (keys.indexOf(key) === -1) keys.push(key);
    });
    return keys;
  }

  function colourValuesMatch(cardValue, filterValue) {
    var cardKeys = colourKeys(cardValue);
    var filterKeys = colourKeys(filterValue);
    return filterKeys.some(function (key) { return cardKeys.indexOf(key) !== -1; });
  }

  function uniqueProductCards(nodes) {
    var seenProducts = Object.create(null);
    return Array.prototype.slice.call(nodes).filter(function (card) {
      var productId = String(card.dataset.productId || '');
      if (!productId) return true;
      if (seenProducts[productId]) {
        card.remove();
        return false;
      }
      seenProducts[productId] = true;
      return true;
    });
  }

  function organiserPrintProperties(card, variantId) {
    var dataNode = card && card.querySelector('[data-lj-variant-properties]');
    if (!dataNode) return {};
    var selected;
    var pdfUrl;
    try {
      selected = JSON.parse(dataNode.textContent)[String(variantId)];
      pdfUrl = new URL(selected._PDF);
    } catch (error) {}
    if (!selected || typeof selected._PDF !== 'string' || !pdfUrl || !/^https?:$/.test(pdfUrl.protocol)) {
      throw new Error(dataNode.dataset.ljPrintError || 'Unable to add this bundle to the basket.');
    }
    var properties = { _PDF: selected._PDF };
    if (selected['_Interior Colour']) properties['_Interior Colour'] = selected['_Interior Colour'];
    return properties;
  }

  function postCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function notifyCartChanged() {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
      bubbles: true,
      cancelable: false
    }));
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read the basket.');
      return response.json();
    });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update the basket.');
      return response.json();
    });
  }

  function standaloneOfferFromResponse(response, variantId, price, title) {
    var responseItem = response && Array.isArray(response.items) ? response.items[0] : response;
    return {
      variantId: Number(variantId),
      price: Number(price),
      title: title || 'Lifestyle Journal Refill',
      lineKey: responseItem && responseItem.key ? String(responseItem.key) : ''
    };
  }

  function addDiscountedSecondRefill(offer, second) {
    if (!offer || !offer.variantId || !second || !second.variantId) {
      return Promise.reject(new Error('Please choose an available Lifestyle Journal Refill.'));
    }

    var bundleId = 'lj_pair_' + Date.now() + '_' + Math.round(Math.random() * 1000000);
    var secondNow = Math.round(second.price * 0.85);
    var bundleWas = offer.price + second.price;
    var bundleNow = offer.price + secondNow;
    var discount = bundleWas > 0 ? Number((((bundleWas - bundleNow) / bundleWas) * 100).toFixed(4)) : 0;

    function isStandaloneFirst(item) {
      var properties = item.properties || {};
      var components = item.item_components || [];
      var originalPrice = Number(item.original_price || item.price || 0);
      var matchesAddedLine = offer.lineKey ? String(item.key || '') === offer.lineKey : Object.keys(properties).length === 0;
      return Number(item.id || item.variant_id) === offer.variantId &&
        originalPrice === offer.price &&
        components.length === 0 &&
        !properties._bundleId &&
        matchesAddedLine;
    }

    function componentRole(component) {
      return String((component.properties || {})._role || '');
    }

    function isOfferPair(item) {
      var components = item.item_components || [];
      if (Number(item.id || item.variant_id) !== offer.variantId) return false;
      if (components.length < 2) {
        return Number(item.original_price || item.price || 0) === bundleNow;
      }
      var hasFirst = components.some(function (component) {
        return componentRole(component) === 'main' && Number(component.id || component.variant_id) === offer.variantId;
      });
      var hasSecond = components.some(function (component) {
        return componentRole(component) === 'half' && Number(component.id || component.variant_id) === second.variantId;
      });
      return hasFirst && hasSecond;
    }

    var pairAdded = false;
    var pairQuantityBefore = 0;

    function pairQuantity(cart) {
      return (cart.items || []).filter(isOfferPair).reduce(function (total, item) {
        return total + Number(item.quantity || 0);
      }, 0);
    }

    function removeRawBundleLines(cart) {
      var rawLines = [];
      (cart.items || []).forEach(function (item, index) {
        if (String((item.properties || {})._bundleId || '') === bundleId) rawLines.push(index + 1);
      });
      rawLines.sort(function (a, b) { return b - a; });
      return rawLines.reduce(function (promise, line) {
        return promise.then(function () { return changeCartLine(line, 0); });
      }, Promise.resolve(cart));
    }

    function rollbackOffer() {
      return getCart().then(function (cart) {
        return removeRawBundleLines(cart);
      }).then(function () {
        return getCart();
      }).then(function (cart) {
        var pairQuantityNow = pairQuantity(cart);
        if (pairQuantityNow <= pairQuantityBefore) return cart;
        var pairIndex = (cart.items || []).findIndex(isOfferPair);
        if (pairIndex < 0) return cart;
        var pair = cart.items[pairIndex];
        return changeCartLine(pairIndex + 1, Math.max(0, Number(pair.quantity || 1) - 1));
      });
    }

    return getCart().then(function (cart) {
      var firstLine = (cart.items || []).find(function (item) {
        return isStandaloneFirst(item);
      });

      if (!firstLine || Number(firstLine.quantity || 0) < 1) {
        throw new Error('Your first Lifestyle Journal Refill is no longer in the basket.');
      }
      pairQuantityBefore = pairQuantity(cart);

      return postCart([
        {
          id: offer.variantId,
          quantity: 1,
          properties: {
            _bundleId: bundleId,
            _parent: offer.variantId,
            _role: 'main',
            _discount: discount,
            _orig_cents: offer.price,
            _now_cents: offer.price,
            _bundle_type: 'lifestyle-journal',
            _bundle_label: offer.title + ' + ' + second.title
          }
        },
        {
          id: second.variantId,
          quantity: 1,
          properties: {
            _bundleId: bundleId,
            _parent: offer.variantId,
            _role: 'half',
            _discount: discount,
            _orig_cents: second.price,
            _now_cents: secondNow,
            _title: second.title,
            _bundle_type: 'lifestyle-journal-refill',
            _offer_percent: 15,
            _bundle_parent_variant: String(offer.variantId),
            _bundle_label: '15% off second Lifestyle Journal Refill'
          }
        }
      ]).then(function () {
        pairAdded = true;
        return getCart();
      }).then(function (updatedCart) {
        if (pairQuantity(updatedCart) <= pairQuantityBefore) {
          throw new Error('The 15% refill offer could not be applied. Your first refill is still in the basket at full price.');
        }
        var firstIndex = (updatedCart.items || []).findIndex(isStandaloneFirst);
        if (firstIndex < 0) throw new Error('The full-price refill could not be linked to this offer.');
        var standalone = updatedCart.items[firstIndex];
        return changeCartLine(firstIndex + 1, Math.max(0, Number(standalone.quantity || 1) - 1));
      }).catch(function (error) {
        if (!pairAdded) throw error;
        return rollbackOffer().catch(function () {}).then(function () { throw error; });
      });
    });
  }

  function openSuccess(success, mode) {
    if (!success) return;
    success.querySelectorAll('[data-lj-success-copy]').forEach(function (copy) {
      copy.hidden = copy.dataset.ljSuccessCopy !== mode;
    });
    success.dataset.ljSuccessMode = mode || '';
    success.hidden = false;
  }

  function init(root) {
    if (root.dataset.ljReady === 'true') return;
    root.dataset.ljReady = 'true';

    var mode = root.dataset.ljPdpMode;

    var picker = root.querySelector('[data-lj-picker]');
    var selectors = Array.prototype.slice.call(root.querySelectorAll('[data-lj-open-picker]'));
    var activeSelector = selectors[0] || null;
    var activeSlot = 'first';
    var choices = { first: null, second: null };
    var planningSecondDiscount = Number(root.dataset.ljPlanningSecondDiscount || 50);
    var planningSecondMultiplier = (100 - planningSecondDiscount) / 100;

    if (mode === 'refill') document.body.classList.add('lj-journal-pdp');

    function lockPage(locked) {
      document.body.classList.toggle('lj-pdp-modal-open', locked);
    }

    function getSelectedView(slot) {
      return root.querySelector('[data-lj-selected][data-lj-slot-selected="' + slot + '"]');
    }

    function getSelector(slot) {
      return root.querySelector('[data-lj-open-picker][data-lj-slot="' + slot + '"]');
    }

    function syncPicker(slot) {
      var choice = choices[slot];
      picker.querySelectorAll('[data-lj-card]').forEach(function (card) {
        var cardVariant = card.dataset.selectedVariantId || ((card.querySelector('[data-lj-variant].is-active') || {}).dataset || {}).variantId;
        var button = card.querySelector('[data-lj-choose]');
        var unavailable = card.dataset.available === 'false';
        var chosenCard = !!choice && String(cardVariant || (button && button.dataset.variantId) || '') === String(choice.variantId);
        card.classList.toggle('is-selected', chosenCard);
        if (button) {
          button.disabled = unavailable || (!!choice && !chosenCard);
          button.textContent = chosenCard ? 'SELECTED' : 'CHOOSE';
        }
      });
    }

    function openPicker(event) {
      if (!picker) return;
      activeSelector = event && event.currentTarget ? event.currentTarget : activeSelector;
      activeSlot = (activeSelector && activeSelector.dataset.ljSlot) || 'first';
      syncPicker(activeSlot);
      picker.hidden = false;
      selectors.forEach(function (selector) {
        selector.setAttribute('aria-expanded', selector === activeSelector ? 'true' : 'false');
      });
      lockPage(true);
      var close = picker.querySelector('[data-lj-close-picker]');
      if (close) close.focus();
    }

    function closePicker() {
      if (!picker) return;
      picker.hidden = true;
      selectors.forEach(function (selector) { selector.setAttribute('aria-expanded', 'false'); });
      lockPage(false);
      if (activeSelector && !activeSelector.hidden) activeSelector.focus();
    }

    function getOrganiserRefillInputs() {
      var formId = root.dataset.productFormId;
      return {
        variant: document.getElementById(formId + '-free-refill-variant'),
        title: document.getElementById(formId + '-free-refill-title'),
        price: document.getElementById(formId + '-free-refill-price'),
        paidVariant: document.getElementById(formId + '-plus-refill-variant'),
        paidTitle: document.getElementById(formId + '-plus-refill-title'),
        paidPrice: document.getElementById(formId + '-plus-refill-price'),
        source: document.getElementById(formId + '-refill-source')
      };
    }

    function writeOrganiserRefill(slot, choice) {
      var inputs = getOrganiserRefillInputs();
      var fields = slot === 'second'
        ? [inputs.paidVariant, inputs.paidTitle, inputs.paidPrice]
        : [inputs.variant, inputs.title, inputs.price];
      var values = choice ? [choice.variantId, choice.title, choice.price] : ['', '', ''];
      fields.forEach(function (field, index) {
        if (field) field.value = values[index];
      });
      if (inputs.source) {
        if (choice) {
          inputs.source.value = 'lifestyle-journal';
        } else {
          var hasFirst = inputs.variant && inputs.variant.value;
          var hasSecond = inputs.paidVariant && inputs.paidVariant.value;
          if (!hasFirst && !hasSecond) inputs.source.value = '';
        }
      }
    }

    function clearOrganiserRefillInputs() {
      writeOrganiserRefill('first', null);
      writeOrganiserRefill('second', null);
    }

    function updateSelectedView(slot, choice) {
      var selected = getSelectedView(slot);
      var selector = getSelector(slot);
      if (!selected || !selector) return;
      selected.querySelector('[data-lj-selected-image]').src = choice.image;
      selected.querySelector('[data-lj-selected-image]').alt = choice.title;
      selected.querySelector('[data-lj-selected-title]').textContent = choice.title;
      selected.querySelector('[data-lj-selected-price]').textContent = mode === 'refill'
        ? money(choice.price)
        : money(Math.round(Number(choice.price) * 0.85)) + ' (15% off)';
      selected.hidden = false;
      selector.hidden = true;
    }

    function setChoice(choice) {
      var slot = mode === 'refill' ? 'first' : activeSlot;
      choices[slot] = choice;
      if (slot === 'first') {
        root.dataset.ljSelectedVariant = choice.variantId;
        root.dataset.ljSelectedPrice = choice.price;
        root.dataset.ljSelectedTitle = choice.title;
      }
      updateSelectedView(slot, choice);
      if (mode === 'organiser') writeOrganiserRefill(slot, choice);
      syncPicker(slot);
      closePicker();
    }

    function clearChoice(slot) {
      slot = slot || 'first';
      choices[slot] = null;
      if (slot === 'first') {
        delete root.dataset.ljSelectedVariant;
        delete root.dataset.ljSelectedPrice;
        delete root.dataset.ljSelectedTitle;
      }
      var selected = getSelectedView(slot);
      var selector = getSelector(slot);
      if (selected) selected.hidden = true;
      if (selector) selector.hidden = false;
      if (mode === 'organiser') writeOrganiserRefill(slot, null);
      syncPicker(slot);
    }

    function getPlanningControl(slot) {
      return root.querySelector('[data-lj-open-planning-picker][data-lj-planning-slot="' + slot + '"]');
    }

    function getPlanningSelectedView(slot) {
      return root.querySelector('[data-lj-planning-selected][data-lj-planning-slot-selected="' + slot + '"]');
    }

    function getPlanningNativeSlot(slot) {
      var planning = document.querySelector('[data-lj-planning-refills]');
      return planning && planning.querySelector(slot === 'second' ? '.refillSlot--plus' : '.refillSlot--free');
    }

    function getPlanningChoice(slot) {
      var inputs = getOrganiserRefillInputs();
      var variant = slot === 'second' ? inputs.paidVariant : inputs.variant;
      var title = slot === 'second' ? inputs.paidTitle : inputs.title;
      var price = slot === 'second' ? inputs.paidPrice : inputs.price;
      var nativeSlot = getPlanningNativeSlot(slot);
      var image = nativeSlot && nativeSlot.querySelector('.refillSlotImg');
      if (!variant || !variant.value) return null;
      return {
        variantId: variant.value,
        title: (title && title.value) || 'Planning Refill',
        price: Number((price && price.value) || 0),
        image: (image && image.src) || ''
      };
    }

    function syncPlanningChoice(slot) {
      var control = getPlanningControl(slot);
      var selected = getPlanningSelectedView(slot);
      var choice = getPlanningChoice(slot);
      if (!control || !selected) return;
      control.hidden = !!choice;
      selected.hidden = !choice;
      if (!choice) return;
      var image = selected.querySelector('[data-lj-selected-image]');
      image.src = choice.image;
      image.alt = choice.title;
      selected.querySelector('[data-lj-selected-title]').textContent = choice.title;
      selected.querySelector('[data-lj-selected-price]').textContent = money(Math.round(choice.price * (slot === 'second' ? planningSecondMultiplier : 0.8))) + (slot === 'second' ? ' (' + planningSecondDiscount + '% off)' : ' (20% off)');
    }

    function clearPlanningChoice(slot) {
      writeOrganiserRefill(slot, null);
      var nativeSlot = getPlanningNativeSlot(slot);
      if (nativeSlot) {
        nativeSlot.classList.remove('is-filled');
        if (slot === 'second') nativeSlot.classList.remove('is-visible');
        var image = nativeSlot.querySelector('.refillSlotImg');
        if (image) {
          image.removeAttribute('src');
          image.style.display = 'none';
        }
        var caption = nativeSlot.querySelector('.refillSlotCaption');
        if (caption) caption.remove();
        var meta = nativeSlot.querySelector('[data-meta-' + (slot === 'second' ? 'plus' : 'free') + ']');
        if (meta) meta.style.display = 'none';
      }
      if (slot === 'first') clearPlanningChoice('second');
      syncPlanningChoice(slot);
    }

    function openPlanningPicker(event) {
      var slot = event.currentTarget.dataset.ljPlanningSlot || 'first';
      var nativeSlot = getPlanningNativeSlot(slot);
      var nativeOpen = nativeSlot && nativeSlot.querySelector('[data-open-picker]');
      if (!nativeOpen) return;
      event.currentTarget.setAttribute('aria-expanded', 'true');
      nativeOpen.click();
    }

    selectors.forEach(function (selector) { selector.addEventListener('click', openPicker); });
    if (picker.querySelector('[data-lj-close-picker]')) picker.querySelector('[data-lj-close-picker]').addEventListener('click', closePicker);
    root.querySelectorAll('[data-lj-remove]').forEach(function (button) {
      button.addEventListener('click', function () { clearChoice(button.dataset.ljSlot || 'first'); });
    });
    root.querySelectorAll('[data-lj-open-planning-picker]').forEach(function (button) {
      button.addEventListener('click', openPlanningPicker);
    });
    root.querySelectorAll('[data-lj-remove-planning]').forEach(function (button) {
      button.addEventListener('click', function () { clearPlanningChoice(button.dataset.ljPlanningSlot || 'first'); });
    });

    if (mode === 'organiser') {
      var organiserInputs = getOrganiserRefillInputs();
      [organiserInputs.variant, organiserInputs.paidVariant].forEach(function (input, index) {
        if (!input) return;
        input.addEventListener('change', function () {
          window.setTimeout(function () { syncPlanningChoice(index === 0 ? 'first' : 'second'); }, 0);
        });
      });
    }

    function getMatchingSwatch(card, colour) {
      return Array.prototype.slice.call(card.querySelectorAll('[data-lj-variant]')).find(function (swatch) {
        return colourValuesMatch(swatch.getAttribute('aria-label') || '', colour);
      });
    }

    function updateCardVariant(card, swatch) {
      if (!card || !swatch || !swatch.dataset.variantId) return;

      card.querySelectorAll('[data-lj-variant]').forEach(function (item) {
        var active = item === swatch;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      card.dataset.selectedVariantId = swatch.dataset.variantId;
      card.dataset.selectedVariantTitle = swatch.dataset.variantTitle;
      card.dataset.selectedVariantPrice = swatch.dataset.variantPrice;
      card.dataset.selectedVariantPriceDisplay = swatch.dataset.variantPriceDisplay;
      card.dataset.selectedVariantImage = swatch.dataset.variantImage;

      var cardPrice = card.querySelector('[data-lj-card-price]');
      var cardImage = card.querySelector('.lj-pdp-card__image img');
      var image320 = swatch.getAttribute('data-variant-image-320') || '';
      var image480 = swatch.getAttribute('data-variant-image-480') || '';
      var image700 = swatch.getAttribute('data-variant-image-700') || swatch.dataset.variantImage || '';
      if (cardPrice) cardPrice.textContent = swatch.dataset.variantPriceDisplay || money(swatch.dataset.variantPrice);
      if (cardImage && image700) {
        cardImage.src = image700;
        if (image320 && image480) {
          cardImage.srcset = image320 + ' 320w, ' + image480 + ' 480w, ' + image700 + ' 700w';
          cardImage.sizes = '(max-width: 700px) 50vw, 25vw';
        } else {
          cardImage.removeAttribute('srcset');
          cardImage.removeAttribute('sizes');
        }
        cardImage.alt = swatch.dataset.variantTitle || '';
      }

      var variantUrl = swatch.dataset.variantUrl || '';
      var imageLink = card.querySelector('[data-lj-card-image-link]');
      var viewLink = card.querySelector('[data-lj-card-view]');
      if (variantUrl && imageLink) imageLink.href = variantUrl;
      if (variantUrl && viewLink) viewLink.href = variantUrl;
    }

    picker.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-lj-variant]');
      if (swatch) {
        var swatchCard = swatch.closest('[data-lj-card]');
        // The filter describes colours the organiser offers; a manual swatch preview should not clear it.
        updateCardVariant(swatchCard, swatch);
        return;
      }

      var card = event.target.closest('[data-lj-card]');
      if (!card) return;
      var choose = event.target.closest('[data-lj-choose]');
      if (!choose) {
        if (event.target.closest('a, button, input, select, textarea, [role="button"], [role="radio"]')) return;
        choose = card.querySelector('[data-lj-choose]');
      }
      if (!choose || choose.disabled) return;
      var activeVariant = card.querySelector('[data-lj-variant].is-active');
      var source = choose.dataset.variantId ? choose : (activeVariant || {});
      if (!source.dataset || !source.dataset.variantId) return;
      setChoice({
        organiserCard: mode === 'refill' ? card : null,
        variantId: card.dataset.selectedVariantId || source.dataset.variantId,
        title: card.dataset.selectedVariantTitle || source.dataset.variantTitle,
        price: card.dataset.selectedVariantPrice || source.dataset.variantPrice,
        image: card.dataset.selectedVariantImage || source.dataset.variantImage || (card.querySelector('img') && card.querySelector('img').src) || ''
      });
    });

    picker.querySelectorAll('[data-lj-filter-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var name = toggle.dataset.ljFilterToggle;
        picker.querySelectorAll('[data-lj-filter-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.ljFilterPanel !== name || !panel.hidden;
        });
        picker.querySelectorAll('[data-lj-filter-toggle]').forEach(function (item) {
          var panel = picker.querySelector('[data-lj-filter-panel="' + name + '"]');
          var active = item === toggle && panel && !panel.hidden;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-expanded', active ? 'true' : 'false');
        });
      });
    });

    var activePrice = null;
    var activeColour = '';
    var filterCards = uniqueProductCards(picker.querySelectorAll('[data-lj-card]'));
    var colourButtons = Array.prototype.slice.call(picker.querySelectorAll('[data-lj-colour]'));

    function cardIsAvailable(card) {
      return card.dataset.available !== 'false';
    }

    function cardMatchesPrice(card) {
      if (!activePrice) return true;
      var colourSwatch = activeColour && getMatchingSwatch(card, activeColour);
      var price = Number((colourSwatch && colourSwatch.dataset.variantPrice) || card.dataset.selectedVariantPrice || card.dataset.price || 0);
      return price >= activePrice.min && (activePrice.max === null || price <= activePrice.max);
    }

    function cardColourValue(card) {
      var availableSwatches = Array.prototype.slice.call(card.querySelectorAll('[data-lj-variant]')).filter(function (swatch) {
        return swatch.getAttribute('aria-label');
      });
      var filterColours = card.dataset.filterColours || '';
      if (availableSwatches.length) {
        return availableSwatches.map(function (swatch) { return swatch.getAttribute('aria-label'); }).join('|') + (filterColours ? '|' + filterColours : '');
      }
      return filterColours || card.dataset.availableColours || card.dataset.colours || '';
    }

    function cardMatchesColour(card, colour) {
      return !colour || colourValuesMatch(cardColourValue(card), colour);
    }

    function updateColourOptions() {
      colourButtons.forEach(function (button) {
        button.hidden = !filterCards.some(function (card) {
          return cardIsAvailable(card) && cardMatchesPrice(card) && cardMatchesColour(card, button.dataset.ljColour || '');
        });
      });

      if (!activeColour) return;
      var activeButton = colourButtons.find(function (button) {
        return button.dataset.ljColour === activeColour;
      });
      if (activeButton && !activeButton.hidden) return;
      activeColour = '';
      colourButtons.forEach(function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
    }

    function syncCardsToColour() {
      if (!activeColour) return;
      filterCards.forEach(function (card) {
        if (!cardIsAvailable(card) || !cardMatchesPrice(card) || !cardMatchesColour(card, activeColour)) return;
        var matchingSwatch = getMatchingSwatch(card, activeColour);
        if (matchingSwatch) updateCardVariant(card, matchingSwatch);
      });
    }

    function applyFilters() {
      updateColourOptions();
      var shown = 0;
      filterCards.forEach(function (card) {
        var matches = cardIsAvailable(card) && cardMatchesPrice(card) && cardMatchesColour(card, activeColour);
        card.hidden = !matches;
        if (!card.hidden) shown += 1;
      });
      var empty = picker.querySelector('[data-lj-picker-empty]');
      if (empty) empty.hidden = shown !== 0;
    }

    picker.querySelectorAll('[data-lj-price-min]').forEach(function (button) {
      button.addEventListener('click', function () {
        var alreadyActive = button.classList.contains('is-active');
        picker.querySelectorAll('[data-lj-price-min]').forEach(function (item) {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        activePrice = alreadyActive ? null : {
          min: Number(button.dataset.ljPriceMin || 0),
          max: button.hasAttribute('data-lj-price-max') ? Number(button.dataset.ljPriceMax) : null
        };
        button.classList.toggle('is-active', !alreadyActive);
        button.setAttribute('aria-pressed', alreadyActive ? 'false' : 'true');
        applyFilters();
      });
    });

    colourButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var alreadyActive = button.classList.contains('is-active');
        colourButtons.forEach(function (item) { item.classList.remove('is-active'); });
        activeColour = alreadyActive ? '' : button.dataset.ljColour;
        button.classList.toggle('is-active', !alreadyActive);
        colourButtons.forEach(function (item) {
          item.setAttribute('aria-pressed', item === button && !alreadyActive ? 'true' : 'false');
        });
        if (activeColour) syncCardsToColour();
        applyFilters();
      });
    });

    filterCards.forEach(function (card) {
      var initialSwatch = card.querySelector('[data-lj-variant].is-active') || card.querySelector('[data-lj-variant]');
      if (initialSwatch) updateCardVariant(card, initialSwatch);
    });
    applyFilters();

    function clearOrganiserPathSelections() {
      clearChoice('first');
      clearChoice('second');
      clearPlanningChoice('first');
      clearOrganiserRefillInputs();
    }

    function setActiveOrganiserPath(value) {
      if (mode !== 'organiser' || !value || root.dataset.ljActivePath === value) return;

      clearOrganiserPathSelections();
      root.dataset.ljActivePath = value;

      root.querySelectorAll('.lj-pdp__path[data-lj-path]').forEach(function (path) {
        var active = path.dataset.ljPath === value;
        path.classList.toggle('is-active', active);
        path.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var lifestyleChoice = root.querySelector('[data-lj-lifestyle-choice]');
      var planningChoice = root.querySelector('[data-lj-planning-choice]');
      var dyorEntry = root.querySelector('[data-lj-dyor-entry]');
      if (lifestyleChoice) lifestyleChoice.hidden = value !== 'lifestyle';
      if (planningChoice) planningChoice.hidden = value !== 'planning';
      if (dyorEntry) {
        dyorEntry.hidden = value !== 'dyor';
        dyorEntry.setAttribute('aria-expanded', value === 'dyor' ? 'true' : 'false');
      }
    }

    root.querySelectorAll('.lj-pdp__path[data-lj-path]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setActiveOrganiserPath(trigger.dataset.ljPath);
      });
    });

    var dyorEntry = root.querySelector('[data-lj-dyor-entry]');
    if (dyorEntry) {
      dyorEntry.addEventListener('click', function () {
        if (root.dataset.ljActivePath !== 'dyor') return;
        var planning = document.querySelector('[data-lj-planning-refills]');
        var nativeEntry = planning && planning.querySelector('[data-dyor-organiser-entry]');
        if (nativeEntry) nativeEntry.click();
      });
    }

    if (mode === 'organiser') {
      var organiserForm = document.getElementById(root.dataset.productFormId);

      function organiserPathValidationMessage() {
        var path = root.dataset.ljActivePath || '';
        if (!path) return 'Please choose one of the organiser options before adding to your basket.';

        if (path === 'planning' || path === 'lifestyle') {
          var inputs = getOrganiserRefillInputs();
          if (!inputs.variant || !inputs.variant.value) {
            return path === 'planning'
              ? 'Please choose your first Planning Refill before adding to your basket.'
              : 'Please choose your first Lifestyle Journal Refill before adding to your basket.';
          }
        }

        if (path === 'dyor') return 'Please select “Start designing now” to create your refill.';
        return '';
      }

      function stopInvalidOrganiserAdd(event) {
        var message = organiserPathValidationMessage();
        if (!message) return false;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.alert(message);
        return true;
      }

      document.addEventListener('click', function (event) {
        if (!organiserForm || !event.target.closest) return;
        var addButton = event.target.closest('.addToCart, button[type="submit"]');
        if (!addButton || !organiserForm.contains(addButton)) return;
        stopInvalidOrganiserAdd(event);
      }, true);

      if (organiserForm) {
        organiserForm.addEventListener('submit', function (event) {
          stopInvalidOrganiserAdd(event);
        }, true);
      }
    }

    if (mode === 'refill') {
      var form = document.getElementById(root.dataset.productFormId);
      var success = root.querySelector('[data-lj-success]');
      var standaloneOffer = null;

      function showSuccess(modeName) {
        openSuccess(success, modeName);
        lockPage(true);
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          var currentChoice = choices.first;
          if (form.dataset.ljSubmitting === 'true') {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();

          var idField = form.querySelector('[name="id"]');
          var quantityField = form.querySelector('[name="quantity"]');
          var refillVariantId = Number(idField && idField.value ? idField.value : root.dataset.mainVariantId);
          var quantity = Math.max(1, Number(quantityField && quantityField.value ? quantityField.value : 1));
          var refillPrice = Number(root.dataset.mainPrice || 0);
          try {
            var productJson = JSON.parse(document.querySelector('[id^="ProductJson-"]').textContent || '{}');
            var selectedVariant = (productJson.variants || []).find(function (variant) { return Number(variant.id) === refillVariantId; });
            if (selectedVariant) refillPrice = Number(selectedVariant.price);
          } catch (ignore) {}

          var refillTitleNode = document.querySelector('.product-form .title');
          var refillTitle = refillTitleNode ? refillTitleNode.textContent.trim() : 'Lifestyle Journal Refill';
          var organiserProperties = {};
          if (currentChoice) {
            try {
              organiserProperties = organiserPrintProperties(currentChoice.organiserCard, currentChoice.variantId);
            } catch (error) {
              window.alert(error.message);
              return;
            }
          }
          var button = form.querySelector('[type="submit"]');
          form.dataset.ljSubmitting = 'true';
          if (button) {
            button.disabled = true;
            button.classList.add('loading');
          }

          if (!currentChoice) {
            postCart([{ id: refillVariantId, quantity: quantity }]).then(function (response) {
              standaloneOffer = standaloneOfferFromResponse(response, refillVariantId, refillPrice, refillTitle);
              showSuccess('refill-only');
              notifyCartChanged();
              document.dispatchEvent(new CustomEvent('lj:cart:add', { detail: { refillOnly: true } }));
            }).catch(function () {
              window.alert('Sorry, something went wrong adding your refill. Please try again.');
            }).finally(function () {
              delete form.dataset.ljSubmitting;
              if (button) {
                button.disabled = false;
                button.classList.remove('loading');
              }
            });
            return;
          }

          var organiserVariantId = Number(currentChoice.variantId);
          var organiserPrice = Number(currentChoice.price || 0);
          var organiserTitle = currentChoice.title || 'A5 Organiser';
          var refillNow = Math.round(refillPrice * 0.85);
          var bundleWas = organiserPrice + (refillPrice * quantity);
          var bundleNow = organiserPrice + (refillNow * quantity);
          var discount = bundleWas > 0 ? Number((((bundleWas - bundleNow) / bundleWas) * 100).toFixed(4)) : 0;
          var bundleId = 'lj_' + Date.now() + '_' + Math.round(Math.random() * 1000000);

          postCart([
            {
              id: organiserVariantId,
              quantity: 1,
              properties: Object.assign({}, organiserProperties, {
                _bundleId: bundleId,
                _parent: organiserVariantId,
                _role: 'main',
                _discount: discount,
                _orig_cents: organiserPrice,
                _now_cents: organiserPrice,
                _bundle_type: 'lifestyle-journal',
                _bundle_label: refillTitle + ' + ' + organiserTitle
              })
            },
            {
              id: refillVariantId,
              quantity: quantity,
              properties: {
                _bundleId: bundleId,
                _parent: organiserVariantId,
                _role: 'first',
                _discount: discount,
                _orig_cents: refillPrice,
                _now_cents: refillNow,
                _title: refillTitle,
                _bundle_type: 'lifestyle-journal-refill',
                _offer_percent: 15,
                _bundle_parent_variant: String(organiserVariantId),
                _bundle_label: '15% off Lifestyle Journal Refill'
              }
            }
          ]).then(function () {
            standaloneOffer = null;
            showSuccess('bundle');
            notifyCartChanged();
          }).catch(function () {
            window.alert('Sorry, something went wrong adding your bundle. Please try again.');
          }).finally(function () {
            delete form.dataset.ljSubmitting;
            if (button) {
              button.disabled = false;
              button.classList.remove('loading');
            }
          });
        }, true);
      }

      if (success) {
        success.addEventListener('click', function (event) {
          var link = event.target.closest('[data-lj-second-refill]');
          if (!link || !success.contains(link) || success.dataset.ljSuccessMode !== 'refill-only' || !standaloneOffer) return;
          event.preventDefault();
          if (success.dataset.ljAddingSecond === 'true') return;

          var second = {
            variantId: Number(link.dataset.variantId || 0),
            price: Number(link.dataset.price || 0),
            title: link.dataset.title || link.textContent.trim()
          };
          if (link.dataset.available === 'false' || !second.variantId || !second.price) {
            window.alert('Sorry, this Lifestyle Journal Refill is currently unavailable.');
            return;
          }

          var label = link.querySelector('span');
          var originalLabel = label ? label.textContent : '';
          success.dataset.ljAddingSecond = 'true';
          success.classList.add('is-adding');
          link.classList.add('is-adding');
          link.setAttribute('aria-busy', 'true');
          if (label) label.textContent = 'ADDING…';

          addDiscountedSecondRefill(standaloneOffer, second).then(function () {
            standaloneOffer = null;
            notifyCartChanged();
            document.dispatchEvent(new CustomEvent('lj:cart:add', { detail: { discountedSecondRefill: true } }));
            window.location.assign((window.theme && theme.routes && theme.routes.cart_url) || '/cart');
          }).catch(function (error) {
            window.alert(error.message || 'Sorry, the second refill could not be added. Please try again.');
          }).finally(function () {
            success.dataset.ljAddingSecond = 'false';
            success.classList.remove('is-adding');
            link.classList.remove('is-adding');
            link.removeAttribute('aria-busy');
            if (label) label.textContent = originalLabel;
          });
        });
      }

      root.querySelectorAll('[data-lj-success-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          root.querySelector('[data-lj-success]').hidden = true;
          lockPage(false);
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (picker && !picker.hidden) closePicker();
      var success = root.querySelector('[data-lj-success]');
      if (success && !success.hidden) {
        success.hidden = true;
        lockPage(false);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-lj-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
